var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/internet/index.js
 ** module id = 390
 ** module chunks = 0
 **/